export default __webpack_public_path__ + "static/media/ic-map.9187d80c.svg";